import { DateTimeBox, DateTimeBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';
import { isRequiredOnceNoteDated } from '../functions/isRequiredOnceNoteDated';

export const BfiApprovalDateField = () => {
    const setup = useStandardLoanStore((state) => state.setup);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <DateTimeBox
            id='setupApprovalDate'
            value={setup.approvalDate}
            onChange={(approvalDate) => updateSetup({ approvalDate })}
            // DateTimeBox doesn't call onChange when the date is cleared (or an invalid date is rejected); it only
            // fails validation. Treat a failed validation as "no date".
            onValidationEvent={(isValid) => {
                if (!isValid) {
                    updateSetup({ approvalDate: undefined });
                }
            }}
            label='BFI Approval'
            required={isRequiredOnceNoteDated(setup)}
            width='160px'
            placeholder='MM/DD/YYYY'
            height='36px'
            layoutStyle={DateTimeBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
